import { render } from "./TravelJournalProject.vue?vue&type=template&id=a2029392&scoped=true"
import script from "./TravelJournalProject.vue?vue&type=script&lang=js"
export * from "./TravelJournalProject.vue?vue&type=script&lang=js"

import "./TravelJournalProject.vue?vue&type=style&index=0&id=a2029392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2029392"]])

export default __exports__